import { z } from "zod";
import {
  type PaymentTermsTaxVariantDTO,
  PaymentTermsTaxVariantSchema,
} from "./payment-terms-templates";

export { PaymentTermsTaxVariantSchema as BankAccountTaxVariantSchema };
export type BankAccountTaxVariantDTO = PaymentTermsTaxVariantDTO;

export const BankAccountTemplateSchema = z.object({
  id: z.string(),
  name: z.string(),
  taxVariant: PaymentTermsTaxVariantSchema,
  content: z.string(),
  contentEn: z.string().nullable(),
  isDefault: z.boolean(),
  status: z.enum(["active", "inactive"]),
  sortOrder: z.number(),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type BankAccountTemplateDTO = z.infer<typeof BankAccountTemplateSchema>;

export const CreateBankAccountTemplateSchema = z.object({
  name: z.string().min(1, "ຕ້ອງປ້ອນຊື່ແມ່ແບບ"),
  taxVariant: PaymentTermsTaxVariantSchema,
  content: z.string().min(1, "ຕ້ອງປ້ອນເນື້ອຫາ"),
  contentEn: z.string().nullable().optional(),
  isDefault: z.boolean().optional(),
  status: z.enum(["active", "inactive"]).optional(),
  sortOrder: z.number().int().optional(),
});
export type CreateBankAccountTemplateDTO = z.infer<
  typeof CreateBankAccountTemplateSchema
>;

export const UpdateBankAccountTemplateSchema = z
  .object({
    name: z.string().min(1).optional(),
    taxVariant: PaymentTermsTaxVariantSchema.optional(),
    content: z.string().min(1).optional(),
    contentEn: z.string().nullable().optional(),
    isDefault: z.boolean().optional(),
    status: z.enum(["active", "inactive"]).optional(),
    sortOrder: z.number().int().optional(),
  })
  .refine((value) => Object.keys(value).length > 0, {
    message: "ຕ້ອງມີຢ່າງນ້ອຍ 1 ຟິວທີ່ແກ້ໄຂ",
  });
export type UpdateBankAccountTemplateDTO = z.infer<
  typeof UpdateBankAccountTemplateSchema
>;

export const UpdateDocumentBankAccountSchema = z.object({
  bankAccountInfo: z.string().nullable(),
  bankAccountInfoEn: z.string().nullable().optional(),
});
export type UpdateDocumentBankAccountDTO = z.infer<
  typeof UpdateDocumentBankAccountSchema
>;
